import { useMemo, useSyncExternalStore } from "react";

export const GLOBAL_SEARCH_DELAY_MS = 250;

/** A request gets its own timer; unsubscribing cancels pending work. */
export function createGlobalSearchDelay(requestKey: string | null) {
  let ready = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const listeners = new Set<() => void>();
  return {
    getSnapshot: () => (ready ? requestKey : null),
    subscribe(listener: () => void) {
      listeners.add(listener);
      if (requestKey !== null && !ready && timer === undefined) {
        timer = setTimeout(() => {
          timer = undefined;
          ready = true;
          for (const notify of listeners) notify();
        }, GLOBAL_SEARCH_DELAY_MS);
      }
      return () => {
        listeners.delete(listener);
        if (!listeners.size && timer !== undefined) {
          clearTimeout(timer);
          timer = undefined;
        }
      };
    },
  };
}

export function useGlobalSearchDelay(requestKey: string | null) {
  const store = useMemo(() => createGlobalSearchDelay(requestKey), [requestKey]);
  return useSyncExternalStore(store.subscribe, store.getSnapshot, () => null);
}
